import React from "react";
import "../styles/refundpolicy.css";

const RefundPolicy = () => {
  return (
    <div className="refund-page">
      <div className="refund-container">
        <div className="refund-content">
          <header className="contact-header">
            <section
              className="hero-section"
              style={{
                backgroundImage: ` url('https://pixeltools.in/img/carousel-1.jpg')`,
                height: "300px",
              }}
            >
              <div className="hero-overlay">
                <div className="hero-content">
                  <h1 className="refund-main-title">Refund Policy</h1>{" "}
                </div>
              </div>
            </section>
          </header>

          <div className="section-title">
            <h5>Refund Information</h5>
          </div>

          <div className="content-box">
            <p>
              Once the refund is approved, it will take 2-8 working days for you
              to receive the order amount, depending on the payment method.
            </p>
          </div>

          <div className="section-title">
            <h5>For credit/debit cards/netbanking/wallets:</h5>
          </div>

          <div className="content-box">
            <p>
              <strong>2-4 business days</strong>
            </p>
          </div>

          <div className="section-title">
            <h5>If the transaction is through NEFT or Cheque:</h5>
          </div>

          <div className="content-box">
            <p>
              The customer needs to provide the below-mentioned details to our
              e-mail id
              <strong> info@pixeltools.in</strong> from his registered e-mail
              id:
            </p>

            <ul>
              <li>Account Number</li>
              <li>Name of the account holder</li>
              <li>IFSC code</li>
            </ul>

            <p>
              After receiving the required information for a refund, the refund
              will be processed within 2 working days and the amount will appear
              in your account within another 2 to 4 working days.
            </p>
          </div>

          <div className="section-title">
            <h5>For EMI payments:</h5>
          </div>

          <div className="content-box">
            <p>
              The refund will be credited within{" "}
              <strong>6-8 working days</strong> from the date of cancellation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
